import { $api } from '../y/api';

export interface XSecret {
    name: string;
    key_version: number;
    secret: Record<string, string>
}

export function xSecretsGetAll(): Promise<XSecret[]> {
    return $api.GET<XSecret[]>('x/secrets');
}

export function xSecretGet(name: string): Promise<XSecret> {
    return $api.GET<XSecret>(`x/secret/${name}`);
}

export function xSecretCreate(name: string, secret: Record<string, string>): Promise<void> {
    return $api.POST('x/secret', { name, secret });
}
